import styled, { css } from "styled-components";

export const defaultStyle = css`
	border: 1px solid var(--nte-graa-500);
	background: var(--nte-graa-400);
	color: black;
	&:hover {
		border: 1px solid var(--nte-graa-500);
		background: var(--nte-graa-400);
		color: black;
		opacity: 0.7;
	}
`;

export const Filter = styled.button`
	border-radius: 4px;
	padding: 6px 12px;
	line-height: 1.3;
	text-align: left;
	width: max-content;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	${defaultStyle}
`;

export const yellowStyle = css`
	border: 1px solid #2440301a;
	background: #fff3ae;
	&:hover {
		border: 1px solid #2440301a;
		background: #fff3ae;
	}
`;

export const blueStyle = css`
	border: 1px solid var(--nte-blaa-50);
	background: var(--nte-blaa-300);
	&:hover {
		border: 1px solid var(--nte-blaa-50);
		background: var(--nte-blaa-300);
	}
`;

export const errorStyle = css`
	border: 1px solid var(--nte-korall);
	background: var(--nte-korall-lys);
	&:hover {
		border: 1px solid var(--nte-korall);
		background: var(--nte-korall-lys);
	}
`;

export const greenStyle = css`
	border: 1px solid var(--varsel-medium-groenn);
	background: var(--varsel-lys-groenn);
	&:hover {
		border: 1px solid var(--varsel-medium-groenn);
		background: var(--varsel-lys-groenn);
	}
`;
